import React, { Component } from 'react'
import * as utils from "../../utils";

import CommentReplies from "./feed-replies";
import FeedContent from "./feed-content";
import FeedPostHead from "./feed-post-head";
import LikePost from "./like-post";
import LikesCount from "./likes-count";
import RepliesCount from "./replies-count";
import ReplyForm from "./reply-form";
import * as rsvpActions from "../../rsvp/actions";

export default class FeedPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleReplyToPostClick = this.handleReplyToPostClick.bind(this);
    this.handleChangeRsvpClick = this.handleChangeRsvpClick.bind(this);
  }

  render(){
    const { index, post } = this.props;
    const { id, likes, liked, post_type, replies, user_submitted } = post;
    const hasLikes = likes > 0;
    const replyCount = replies.total_count;
    const hasReplies = replyCount > 0;
    const postClass = user_submitted? "user-submitted": "";
    const canComment = utils.canComment();
    const showReplyForm = canComment;
    const isPostByUser = Boolean(post && post.guest_id && post.guest_id === guest_id);
    const isRsvpPost = Boolean(post_type && post_type.toLowerCase() === 'rsvp');

    return (
      <div className={`feed-post-container simple-shadowbox ${postClass}`}>
        <div className={`feed-post feed-post-${post_type}`}>
          <FeedPostHead post={post}/>
          <FeedContent post={post}/>
          {
            evite.features.isEnabled('feed-post-change-rsvp-button') &&
            utils.hasRsvpd() &&
            utils.isGuest() &&
            isPostByUser &&
            isRsvpPost &&
            !utils.eventHasPassed() &&

              <div className="change-rsvp-button-container">
                <div
                  className={
                    'change-rsvp-button button-primary-inverse ' +
                    (evite.detects.isDesktop? 'small-32': 'small')
                  }
                  onClick={this.handleChangeRsvpClick}>
                  Change RSVP
                </div>
              </div>
          }
          <div className="feed-footer">
            { canComment &&
              <div className="feed-post-actions">
                <LikePost postId={id} likes={likes} liked={liked}/>
              </div>
            }
            { (hasLikes || hasReplies) &&
              <div className="post-info">
                { hasLikes &&
                <LikesCount likes={likes} liked={liked} likedBy={post.liked_by} detailedInfo={true}/>
                }
                { hasReplies &&
                  <RepliesCount postId={id} replyCount={replyCount} />
                }
              </div>
            }
          </div>
        </div>
        { (canComment || hasReplies) &&
          <div className="reply-container">
            { hasReplies &&
              <CommentReplies replies={replies} postId={id} onReplyClick={showReplyForm? this.handleReplyToPostClick: null}  />
            }
            { showReplyForm &&
              <ReplyForm postId={id} ref={(c) => {
                this.replyForm = c;
              }}/>
            }
          </div>
        }
      </div>
    );
  }

  handleReplyToPostClick(event, reply){
    event.preventDefault();
    this.replyForm && this.replyForm.replyToReply(reply);
  }

  handleChangeRsvpClick(event) {
    event.preventDefault();

    evite.sleep(0)
      .then(function () {
        window.app.router.toRoute('rsvp');
        rsvpActions.showRsvpForm(true);
      })
      .then(function () {
        window.NavigationView.enqueueCommand('showRsvpForm');
      });

    return false;
  }
};




// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-post.es6